import React from "react";
import FormControl from "@/components/FormControl/FormControl";
import type { Control, FieldValues, UseFormRegister, UseFormStateReturn } from "react-hook-form";
type FormFieldConfig = {
  controlType: string;
  label: string;
  placeholder?: string;
  validations?: Record<string, any>;
  isRequired?: boolean;
  autoComplete?: string;
  isControlled?: boolean;
  props?: Record<string, any>;
  hide?: boolean;
};

type FormConfig = Record<string, FormFieldConfig>;
export default function formRenderer<TFieldValues extends FieldValues>(
  formConfig: FormConfig,
  formState: UseFormStateReturn<TFieldValues>,
  register: UseFormRegister<TFieldValues>,
  control?: Control<TFieldValues>
)  {
  return Object.entries(formConfig || {}).map(([name, obj]) => {
    if (obj?.hide) return;
    return (
      <FormControl
        key={name}
        name={name}
        controlType={obj.controlType}
        label={obj.label}
        placeholder={obj.placeholder || `Enter ${obj.label}`}
        validations={obj.validations}
        errorMessage={formState?.errors?.[name]?.message}
        isRequired={obj.isRequired}
        autoComplete={obj.autoComplete || "new-password"}
        {...(obj.isControlled && control ? { control } : { register })}
        {...(obj.props || {})}
      />
    );
  });
}
